import styles from './ActionRow.module.css';

interface ActionRowProps {
  label: string;
  description?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export function ActionRow({ label, description, iconLeft, iconRight, onClick, disabled }: ActionRowProps) {
  return (
    <button type="button" className={styles.row} onClick={onClick} disabled={disabled}>
      {iconLeft}
      <span className={styles.body}>
        <span className={styles.label}>{label}</span>
        {description && <span className={styles.description}>{description}</span>}
      </span>
      {iconRight}
    </button>
  );
}
